export default __webpack_public_path__ + "static/media/product02.b61ac888.png";